import $ from "jquery";
import Cookies from "./libs/tomcat-cookies.js";
import {
	sessionKey,
	locale,
	navigation,
	setDesktopCookies
} from './store/cookies.js';

import {
	eventType
} from "./config/settings.js";
import websocket from "./websocket/websocket-event-esm.js";

const $globalNavigation = document.getElementsByClassName('global-menu')[0];
const $languageSelector = document.getElementById('language-settings-container');
const $switchToWebsite = document.getElementById('switchToWebsite');


// close support nav
function closeSupportNav() {
	document.querySelector('.support-nav').classList.remove('support-nav--is-open');
}

function menuItemSelected($menuItem) {
	$globalNavigation.getElementsByClassName('link-list__item')[0].classList.remove('link-list__item--is-selected');
	$menuItem.addClass('link-list__item--is-selected');
}

function selectMenuItem($menuItem) {
	if (!$menuItem[0].classList.contains('link-list__item--is-selected')) {
		const link = $menuItem.children('.link-list__item a').attr('href');
		if (link !== '#' && link) {
			Cookies.set('navigation', $menuItem.data('product'), {
				path: '/'
			});
		}
		menuItemSelected($menuItem);
	}
}

function checkSessionCookieAndChangeIcon() {
	if (sessionKey()) {
		const $pageHead = document.getElementsByClassName('pusher')[0].getElementsByClassName('page-head')[0];
		const pageHeadIconLogin = $pageHead.getElementsByClassName('header-icon--login')[0];
		pageHeadIconLogin.classList.remove('u-show');
		pageHeadIconLogin.classList.add('u-hide');

		const pageHeadIconAccount = $pageHead.getElementsByClassName('header-icon--account')[0];
		pageHeadIconAccount.classList.remove('logged-out', 'u-hide');
		pageHeadIconAccount.classList.add('u-show');
	}
}

function changeLanguage(newLocale) {
	if (locale() !== newLocale) {
		Cookies.set('locale', newLocale, {
			path: '/'
		});

		const url = '/locale/change';
		const options = {
			method: 'POST',
			credentials: 'include',
			headers: {
				"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
			},
			body: 'locale=' + newLocale
		};

		if (sessionKey()) {
			fetch(url, options)
				.then(location.reload());
		} else {
			location.reload();
		}
	}
}

function switchToWebsite() {
	websocket.disconnect();
	setDesktopCookies();
	const desktopHostname = location.host.replace('mobile.', '').replace('mobile-', '');
	window.location.href = `${location.protocol}//${desktopHostname}/`;
}

function displayLanguageList(menuItem) {
	menuItem.getElementsByClassName('custom-select')[0].classList.remove('u-hide');

	const options = $languageSelector.getElementsByTagName('option');
	for (let i = 0; i < options.length; i += 1) {
		const option = options[i];
		if (option.dataset.locale === locale()) {
			option.selected = true;
		} else {
			option.selected = false;
		}
	}
}

// Add scrollscope to deactivate scrolls on menus
// myScrollScopeInstance.bind(document);
function init() {
	//websocket connection
	if (sessionKey()) {
		websocket.connect(sessionKey());
	}

	// CLICK HANDLERS
	$($switchToWebsite).click((event) => {
		switchToWebsite();
		event.stopPropagation();
	});

	/* Select language selector */
	const languageSelectorItem = document.getElementsByClassName('js-language-selector')[0];
	languageSelectorItem.onclick = (event) => {
		displayLanguageList(event.currentTarget);
		event.stopPropagation();
		$globalNavigation.getElementsByClassName('link-list__item')[0].classList.remove('link-list__item--is-selected');
		event.currentTarget.classList.add('link-list__item--is-selected');
	};

	const languageSelectElem = languageSelectorItem.getElementsByTagName('select')[0];
	languageSelectElem.onchange = (event) => {
		changeLanguage(event.currentTarget.selectedOptions[0].dataset.locale);
		event.stopPropagation();
	};

	// will avoid re-trigger the click handler on the menus
	$($languageSelector).on(eventType, (event) => {
		event.stopPropagation();
		event.preventDefault();
	});

	$($globalNavigation).on(eventType, '.link-list__item', function(event) {
		if (event.currentTarget === this) {
			//event.preventDefault();
			event.stopPropagation();
			selectMenuItem($(this));
		}
	});

	// check cookie to highlight menu
	if (navigation()) {
		menuItemSelected($($globalNavigation).find(`.link-list__item[data-product="${navigation()}"]`));
	}

	// check cookie to show account menu icon
	checkSessionCookieAndChangeIcon();
	$('.support-nav').on(eventType, '.js-close-support-nav', (e) => {
		e.preventDefault();
		closeSupportNav();
	});

	// Swipe events for menues - close menues when user swipe on them
	$('.global-menu').swipe({
		// Generic swipe handler for all directions, parameters: (event, direction, distance, duration, fingerCount, fingerData)
		swipe(direction) {
			if (direction === 'left') {
				$(this).removeClass('menu--is-open');
			}
		}
	});

	$('.account-menu').swipe({
		swipe(direction) {
			if (direction === 'right') {
				$(this).removeClass('menu--is-open');
			}
		}
	});
}

export default init;



// WEBPACK FOOTER //
// ./mobile-core/src/navigation.js